import React from 'react';
import { withStyles, makeStyles, Theme, useTheme } from '@material-ui/core/styles';
import Menu, { MenuProps } from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import CircularProgress from '@material-ui/core/CircularProgress';
import DoneIcon from '@material-ui/icons/CheckCircleOutlined';
import ArrowDropDownIcon from '@material-ui/icons/KeyboardArrowDown';
import ScheduleIcon from '@material-ui/icons/AvTimerOutlined';
import LightbulbIcon from '@material-ui/icons/EmojiObjectsOutlined';
import FancyButton from '../../../components/Button';
import { ConnectorDeal, ConnectorDealStatus } from '../../../types/types';
import { useConnectorDeals } from '../../../contexts';

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  menuRoot: {
    padding: `0px ${theme.spacing(2)}px`,
    border: '1px solid #d3d4d5'
  },
  itemIcon: {
    minWidth: 30
  }
}));


// theme.palette.primary.main
const StyledMenuItem = withStyles((theme) => ({
  root: {
    // '&:focus': {
    //   backgroundColor: 'gray',
    //   '& .MuiListItemIcon-root, & .MuiListItemText-primary': {
    //     color: theme.palette.common.white
    //   }
    // }
  }
}))(MenuItem);

type ConnectorDealMoveToButtonProps = {
  deal: ConnectorDeal;
  onDealStatusUpdate?: (status: ConnectorDealStatus) => void;
};

const ConnectorDealMoveToButton: React.FC<ConnectorDealMoveToButtonProps> = ({ deal, onDealStatusUpdate }) => {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [loading, setLoading] = React.useState<boolean>(false);
  const { updateConnectorDealStatus } = useConnectorDeals();

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleStatusClick = async (newStatus: ConnectorDealStatus) => {
    setAnchorEl(null);
    setLoading(true);
    await updateConnectorDealStatus(deal.id, newStatus);
    if (onDealStatusUpdate) onDealStatusUpdate(newStatus);
    setLoading(false);
  };

  const iconForStatus = {
    [ConnectorDealStatus.New]: LightbulbIcon,
    [ConnectorDealStatus.InProgress]: ScheduleIcon,
    [ConnectorDealStatus.Done]: DoneIcon
  };

  const textForStatus = {
    [ConnectorDealStatus.New]: 'New',
    [ConnectorDealStatus.InProgress]: 'In progress',
    [ConnectorDealStatus.Done]: 'Done'
  };

  const theme = useTheme();
  const styles = useStyles(theme);

  return (
    <div>
      <FancyButton
        variant='contained'
        color='secondary'
        size='small'
        endIcon={<ArrowDropDownIcon />}
        onClick={handleClick}
        disabled={loading}
      >
        {loading ? <CircularProgress size={20} /> : 'Move to'}
      </FancyButton>
      <Menu
        elevation={0}
        classes={{ paper: styles.menuRoot }}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center'
        }}
        id='customized-menu'
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {[ConnectorDealStatus.New, ConnectorDealStatus.InProgress, ConnectorDealStatus.Done].map((status) => {
          const IconComponent = iconForStatus[status];
          return status === deal.status ? null : (
            <StyledMenuItem key={`${deal.id}_${status}`} onClick={() => handleStatusClick(status)}>
              <ListItemIcon className={styles.itemIcon}>
                <IconComponent fontSize='small' />
              </ListItemIcon>
              <ListItemText primary={textForStatus[status]} />
            </StyledMenuItem>
          );
        })}
      </Menu>
    </div>
  );
};

export default ConnectorDealMoveToButton;
